/* Bestie Skin Club theme — small, dependency-free enhancements.
   Every feature degrades to a plain HTML form or link without JS. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Announcement rotator ---------- */
  const notes = $$('.announcement__item');
  if (notes.length) {
    let i = 0;
    notes[0].classList.add('is-active');
    if (notes.length > 1 && !reduceMotion) {
      setInterval(() => {
        notes[i].classList.remove('is-active');
        i = (i + 1) % notes.length;
        notes[i].classList.add('is-active');
      }, 4500);
    }
  }

  /* ---------- Mobile menu ---------- */
  const menu = $('[data-mobile-menu]');
  const setMenu = (open) => {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    document.body.classList.toggle('is-locked', open);
    $$('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
    if (open) $('a', menu)?.focus();
  };
  $$('[data-menu-toggle]').forEach((btn) => btn.addEventListener('click', () => setMenu(!menu.classList.contains('is-open'))));

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    input.value = Math.max(Number(input.min || 0), Number(input.value || 1) + Number(step.dataset.qtyStep));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    document.body.classList.add('is-locked');
    $('[data-drawer-close].icon-button', drawer)?.focus();
  };
  const closeDrawer = () => {
    if (!drawer?.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    lastFocus?.focus?.();
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    const trigger = e.target.closest('[data-cart-trigger]');
    if (trigger && drawer && window.theme?.cartDrawer) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawer();
    if (menu?.classList.contains('is-open')) setMenu(false);
  });

  const renderCart = async () => {
    const res = await fetch(`${window.theme.routes.root}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer-inner]', html);
    const current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    const count = Number(fresh?.dataset.count || 0);
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
  };

  // Any form[data-product-form] adds via AJAX. Supports single `id` forms
  // and multi-item bundle forms (items[n][id] / items[n][quantity]).
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !window.theme?.cartDrawer || !drawer) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const label = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const res = await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart.');
      }
      await renderCart();
      openDrawer();
    } catch (err) {
      alert(err.message);
    } finally {
      if (button) { button.disabled = false; button.innerHTML = label; }
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    await fetch(window.theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(input.dataset.lineQty), quantity: Number(input.value) }),
    });
    if (input.closest('[data-cart-drawer]')) await renderCart();
    else window.location.reload();
  });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    const scope = remove.closest('[data-cart-drawer]') || document;
    const input = scope.querySelector(`[data-line-qty="${remove.dataset.lineRemove}"]`);
    if (input) { input.value = 0; input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* ---------- Product gallery + variants ---------- */
  $$('[data-product]').forEach((root) => {
    const main = $('[data-main-media]', root);
    $$('[data-thumb]', root).forEach((thumb) => thumb.addEventListener('click', () => {
      const img = $('img', main);
      img.src = thumb.dataset.src;
      img.srcset = thumb.dataset.srcset;
      img.alt = thumb.dataset.alt;
      $$('[data-thumb]', root).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
    }));

    const select = $('[data-variant-select]', root);
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      const idInput = $('[data-variant-id]', root);
      if (idInput) idInput.value = select.value;
      $$('[data-price]').forEach((el) => { el.textContent = opt.dataset.price; });
      $$('[data-add-button]').forEach((b) => {
        b.disabled = opt.dataset.available !== 'true';
        b.textContent = opt.dataset.available === 'true' ? 'Add to Bag' : 'Sold Out';
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
  });

  /* Sticky add-to-bag bar on mobile */
  const stickyBar = $('[data-sticky-atc]');
  const mainButton = $('[data-product] [data-add-button]');
  if (stickyBar && mainButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', show);
      stickyBar.setAttribute('aria-hidden', String(!show));
      $('[data-sticky-add]', stickyBar).tabIndex = show ? 0 : -1;
    }).observe(mainButton);
    $('[data-sticky-add]', stickyBar)?.addEventListener('click', () => mainButton.click());
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }
})();
